import type { FeatureBlockContent, HeroContent } from '../types';
import {
  businessClosing as businessClosingEn,
  businessFaq as businessFaqEn,
  businessFeeBanner as businessFeeBannerEn,
  businessGlobalTeam as businessGlobalTeamEn,
  businessHero as businessHeroEn,
  businessInvoices as businessInvoicesEn,
  businessPaths as businessPathsEn,
  businessReceive as businessReceiveEn,
  businessSavingsCalculator as businessSavingsCalculatorEn,
  businessTrust as businessTrustEn,
} from '../business';

export const businessHero: HeroContent = {
  ...businessHeroEn,
  title: 'ادفع لفريقك\nبرسوم 0',
  cta: { ...businessHeroEn.cta, label: 'قدّم لدفع الرواتب' },
  secondaryCta: { ...businessHeroEn.secondaryCta!, label: 'اطلب عرض توضيحي' },
  image: {
    ...businessHeroEn.image,
    alt: 'لوحة تحكم nsave للشركات وبتعرض رصيد بالدولار والمعاملات على شاشة مكتب',
  },
};

export const businessFeeBanner: typeof businessFeeBannerEn = {
  ...businessFeeBannerEn,
  text: 'رسوم الـ 200 دولار بتترد بعد أول دفعة رواتب.',
  termsLink: { ...businessFeeBannerEn.termsLink, label: 'تطبق الشروط والأحكام.' },
  waitlistText: 'لو بتدور على حساب أعمال عام، تقدر',
  waitlistLink: { ...businessFeeBannerEn.waitlistLink, label: 'تنضم لقائمة الانتظار.' },
};

export const businessTrust: typeof businessTrustEn = {
  ...businessTrustEn,
  title: 'حساب رواتب مصمم للفرق الدولية',
  body: 'موّل حساب واحد، وادفع لفريقك الدولي، وخلي الموظفين يستلموا رواتبهم في حساباتهم على nsave.',
  link: { ...businessTrustEn.link!, label: 'شوف إزاي بتشتغل' },
};

export const businessPaths: typeof businessPathsEn = {
  title: 'بتدور على حساب أعمال عام بدلًا من كده؟',
  items: [
    {
      ...businessPathsEn.items[0],
      title: 'انضم لقائمة انتظار حسابات الأعمال',
      description:
        'بنعيد بناء nsave للأعمال من الأساس، علشان كده وقفنا فتح حسابات الأعمال العامة الجديدة لحد آخر السنة. انضم لقائمة الانتظار وهتكون أول من يعرف لما نفتح من جديد.',
      cta: { ...businessPathsEn.items[0].cta, label: 'انضم لقائمة انتظار حسابات الأعمال' },
    },
  ],
};

export const businessReceive: FeatureBlockContent = {
  ...businessReceiveEn,
  title: 'قلّل تكلفة الرواتب الدولية',
  rows: [
    {
      ...businessReceiveEn.rows[0],
      title: '1. موّل حساب الرواتب',
      description: 'أضف أموال الرواتب لحساب nsave للأعمال قبل موعد دفع الرواتب.',
    },
    {
      ...businessReceiveEn.rows[1],
      title: '2. ادفع لموظفينك',
      description:
        'فريقك يفتح حساب nsave مجاني في دقائق باستخدام الإيميل، وبعدها تدفع لكل موظف من حساب واحد.',
    },
    {
      ...businessReceiveEn.rows[2],
      title: '3. فريقك يستلم الراتب',
      description: 'تحويلات الرواتب بتوصل فورًا لحسابات موظفينك على nsave برسوم تحويل $0 من nsave.',
    },
  ],
};

export const businessSavingsCalculator: typeof businessSavingsCalculatorEn = {
  ...businessSavingsCalculatorEn,
  title: 'قد إيه ممكن توفر في الرواتب؟',
  description:
    'قارن اللي بتدفعه النهارده مع nsave. من غير اشتراك شهري ومن غير رسوم تحويل من nsave.',
  presetsLabel: 'ابدأ من فريق نموذجي',
  presets: [
    { label: 'فريق صغير', employees: 5 },
    { label: 'فريق بيكبر', employees: 25 },
    { label: 'فريق كبير', employees: 100 },
  ],
  employeesLabel: 'عدد الموظفين اللي بتدفعلهم كل شهر',
  nsaveColumnLabel: 'مع nsave',
  providerColumnLabel: 'مزود الخدمة الحالي',
  feeLabel: 'رسوم كل تحويل',
  subscriptionLabel: 'اشتراك لكل موظف / شهر',
  nsaveNote: 'الرواتب بين حسابات nsave. دايمًا $0.',
  providerNote: 'غيّر الأرقام دي للي بيحاسبك بيه مزود الخدمة الحالي.',
  savingsLabel: 'ممكن توفر خلال 12 شهر',
  monthlySavingsSuffix: 'كل شهر',
  breakdownLabel: 'اللي هتبطل تدفعه كل سنة',
  transferFeesLabel: 'رسوم التحويل',
  subscriptionsLabel: 'اشتراكات الرواتب',
  totalLabel: 'إجمالي التوفير',
  primaryCta: { ...businessSavingsCalculatorEn.primaryCta, label: 'قدّم لدفع الرواتب' },
  secondaryCta: { ...businessSavingsCalculatorEn.secondaryCta, label: 'احجز عرض توضيحي' },
  disclaimer:
    'تقدير مش عرض. على أساس دفعة رواتب واحدة في الشهر. nsave مش بتاخد رسوم على تحويلات الرواتب بين حسابات nsave؛ ممكن تنطبق رسوم تحويل عملات أو رسوم صرف محلية حسب السوق. تنطبق رسوم تقديم 200 دولار. تطبق الشروط والأحكام.',
};

export const businessGlobalTeam: FeatureBlockContent = {
  ...businessGlobalTeamEn,
  title: 'حساب رواتب واحد لفريقك العالمي',
  rows: [
    {
      ...businessGlobalTeamEn.rows[0],
      title: 'ادعم فرقك الدولية',
      description: 'ادفع للموظفين والمتعاقدين في الأسواق المدعومة.',
    },
    {
      ...businessGlobalTeamEn.rows[1],
      title: 'ادفع بالإيميل أو ntag',
      description: 'استخدم بيانات موظف بسيطة بدل ما تدخل بيانات بنكية طويلة كل شهر.',
    },
    {
      ...businessGlobalTeamEn.rows[2],
      title: 'مرونة أكتر للموظفين',
      description: 'الموظفين يختاروا يحتفظوا بالراتب أو يصرفوه أو يسحبوه حسب المتاح.',
    },
    {
      ...businessGlobalTeamEn.rows[3],
      title: 'كبّر النظام مع فريقك',
      description: 'أضف الموظفين وخلي بيانات الرواتب في مكان واحد مع نمو فريقك.',
    },
  ],
};

const invoiceRows = [
  ['دفعات رواتب فورية', 'الرواتب بتوصل لحسابات موظفينك على nsave فورًا، عشان فريقك يقبض في ميعاده.'],
  ['مصممة للفرق الدولية', 'ادفع للموظفين والمتعاقدين في أسواق مختلفة من حساب مركزي واحد.'],
  [
    'دفعات رواتب جماعية',
    'ابعت الرواتب لعدة موظفين باستخدام ntag أو الإيميل، وقلل الدفعات اليدوية المتكررة.',
  ],
  [
    'مرونة أكتر للموظفين',
    'البطاقة الافتراضية وميزات الاستثمار متاحة في أسواق محددة، والتوفر بيختلف حسب السوق.',
  ],
] as const;

export const businessInvoices: FeatureBlockContent = {
  ...businessInvoicesEn,
  title: 'ليه الشركات بتستخدم nsave للرواتب',
  rows: businessInvoicesEn.rows.map((row, index) => ({
    ...row,
    title: invoiceRows[index][0],
    description: invoiceRows[index][1],
  })),
};

export const businessClosing: typeof businessClosingEn = {
  ...businessClosingEn,
  title: 'ابدأ nroll لفريقك النهارده',
  body: 'قدّم على حساب رواتب nroll وادفع لفريقك الدولي برسوم تحويل $0 من nsave.',
  image: { ...businessClosingEn.image, alt: 'فريق nsave مع بعض في المكتب' },
  primaryCta: { ...businessClosingEn.primaryCta, label: 'قدّم لدفع الرواتب' },
  secondaryCta: { ...businessClosingEn.secondaryCta, label: 'اطلب عرض توضيحي' },
};

/** Draft only; `localized.ts` serves the approved English FAQ until sign-off. */
export const businessFaq = businessFaqEn;
